/**
 * One-time migration: clear the old uploadManager IndexedDB ('upload-files-db')
 * on first launch of the new renderer (2.2.2+). Prevents stale tasks from
 * being retried and causing duplicate gallery items when the new pipeline
 * has already uploaded files.
 *
 * See: Upload Migration Risk Analysis plan — "Clear old IndexedDB tasks on new renderer launch"
 */

const MIGRATION_FLAG_KEY = 'dreambooth-upload-idb-migrated-2.2.2'
const LEGACY_DB_NAME = 'upload-files-db'

function deleteDatabase(name: string): Promise<void> {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === 'undefined') {
      resolve()
      return
    }
    const request = indexedDB.deleteDatabase(name)
    request.onsuccess = (): void => resolve()
    request.onerror = (): void => reject(request.error)
    request.onblocked = (): void => resolve() // Still resolve so we don't block; DB may be in use
  })
}

/**
 * Run once per install. Clears legacy upload IndexedDB and sets a flag so we don't clear again.
 */
export async function runUploadIdbMigrationOnce(): Promise<void> {
  if (typeof localStorage === 'undefined') return
  try {
    if (localStorage.getItem(MIGRATION_FLAG_KEY) === 'done') return
    await deleteDatabase(LEGACY_DB_NAME)
    localStorage.setItem(MIGRATION_FLAG_KEY, 'done')
  } catch {
    // Non-fatal; avoid breaking app load
  }
}
